import { useQuery } from '@tanstack/react-query';
import { getVacationBalance } from '../services/api/vacationBalance';

/** Phase 71 (VAC-01..05/07) — TanStack Query read hook for the HR-only vacation balance endpoint. */
export function useVacationBalance(userId: number | undefined, year: number) {
  return useQuery({
    queryKey: ['vacationBalance', userId, year],
    queryFn: () => getVacationBalance(userId!, year),
    enabled: !!userId,
  });
}
